import { render, staticRenderFns } from "./ProductEditMeli.vue?vue&type=template&id=0f70f13e&"
import script from "./ProductEditMeli.vue?vue&type=script&lang=js&"
export * from "./ProductEditMeli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports